<template>
  <v-card :elevation="0">
    <v-toolbar flat color="transparent">
      <v-toolbar-title>{{
        this.$Amplify.I18n.get("Saved Queries")
      }}</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-btn text icon @click.stop="refresh" color="secondary">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-toolbar>

    <v-alert
      class="mt-4"
      icon="mdi-alert"
      border="left"
      text
      color="error"
      transition="fade-transition"
    >
      <v-row align="center">
        <v-col class="grow">
          Si tiene consultas almacenadas con el filtro <strong>AÑO: 2022 </strong> deberá actualizar sus consultas 
          con el <strong>AÑO: 2023</strong>. Para hacerlo siga los siguientes pasos: <br/>1. Copie el nombre de la consulta (lo necesitará en el último paso)<br/> 2. Ejecute la consulta. (Se moverá hacia la pestaña <strong>FILTROS</strong>) <br/>3. Actualice el filtro AÑO y seleccione <strong>2023</strong> <br/>4. Regrese a la pestaña <strong>CONSULTAS</strong>, seleccione y elimine la consulta almacenada que ejecutó en el paso 2 y vaya a la pestaña <strong>FILTROS</strong> <br/>5. Haga clic en <strong>GUARDAR CONSULTA </strong> y pegue el nombre de la consulta anterior  <br/>
        </v-col>
      </v-row>
    </v-alert>

    <v-alert
      v-if="alert.message"
      v-model="alert.show"
      prominent
      dense
      dismissible
      :type="alert.type || 'error'"
      transition="scale-transition"
    >
      <v-layout align-center wrap>
        <div>
          {{ alert.message }}
        </div>
      </v-layout>
    </v-alert>

    <v-card-text class="ma-0 pa-0">
      <!-- <span v-if="filters.length > 0" class="subheading hidden-sm-and-down"> Tiene {{filters.length}} filtro{{filters.length>1?"s":""}}</span>
      <span v-else class="subheading hidden-sm-and-down"> No tiene filtros</span>  -->

      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="queries"
        class="elevation-0"
        item-key="uuid"
        show-select
        :loading="loading"
      >
        <template v-slot:header.data-table-select="{ on, props }">
          <v-simple-checkbox
            :ripple="false"
            color="primary"
            v-bind="props"
            v-on="on"
          ></v-simple-checkbox>
        </template>
        <template v-slot:item.data-table-select="{ isSelected, select }">
          <v-simple-checkbox
            :ripple="false"
            color="primary"
            :value="isSelected"
            @input="select($event)"
          ></v-simple-checkbox>
        </template>
        <template v-slot:item.descripcion="{ item }">
          <span> {{ item.descripcion }} </span><br />
        </template>
        <template v-slot:item.options="{ item }">
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              :color="hover ? 'primary' : ''"
              icon
              @click.stop="editQuery(item)"
            >
              <v-icon>mdi-pencil-outline</v-icon>
            </v-btn>
          </v-hover>
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              :color="hover ? 'primary' : ''"
              icon
              @click.stop="play(item)"
            >
              <v-icon>mdi-play-outline</v-icon>
            </v-btn>
          </v-hover>
        </template>
        <template v-slot:no-data>
          No tiene consultas almacenadas
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions>
      <v-btn
        v-if="selected.length > 0"
        color="primary"
        text
        @click="deleteQueries"
        class="subtitle-2"
        :disabled="loadingDeleteBtn"
      >
        {{ this.$Amplify.I18n.get("Delete selected") }} [{{
          selected.length
        }}]</v-btn
      >
      <v-spacer></v-spacer>
    </v-card-actions>

    <v-dialog v-model="dialog" persistent max-width="500px">
      <save-query></save-query>
    </v-dialog>

    <v-dialog v-model="deleteDialog" persistent max-width="528px">
      <ValidationObserver ref="obs" v-slot="{ invalid, validated }">
        <v-card>
          <v-card-title>
            <div class="d-flex flex-row">
              <v-avatar color="error" size="48">
                <v-icon size="32" color="red lighten-4"
                  >mdi-trash-can-outline</v-icon
                >
              </v-avatar>

              <span class="pl-4">
                ¿Está seguro que desea eliminar las consultas almacenadas
                seleccionadas?
              </span>
            </div>
          </v-card-title>
          <v-card-text class="subtitle-1">
            Para estar seguro de que desea ejecutar esa acción, escriba la
            palabra
            <strong>BORRAR</strong> (en mayúsculas) en el casillero y a
            continuación haga clic en <strong>ACEPTAR</strong>

            <ValidationProvider
              name="palabra"
              rules="required"
              v-slot="{ errors, valid }"
            >
              <v-text-field
                class="mt-4"
                v-model="palabra"
                autofocus
                :error-messages="errors"
                :success="valid"
                outlined
                clearable
              ></v-text-field>
            </ValidationProvider>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              :disabled="invalid || !validated || palabra != 'BORRAR'"
              color="primary"
              outlined
              @click="deleteSelected"
            >
              Aceptar
            </v-btn>
            <v-btn
              color="error"
              @click="
                deleteDialog = false;
                palabra = '';
              "
            >
              Cancelar
            </v-btn>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>
  </v-card>
</template>

<script>
//import EventBus from "@/events/EventBus";
import { AmplifyEventBus } from "aws-amplify-vue";
import { mapGetters, mapActions } from "vuex";
import { deleteConsultas } from "@/api/private/consultas";
//import unzipHeadersAndRows from "@/services/elastic/response/jsonUtils";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      fab: false,
      loadingBtn: false,
      palabra: "",
      loadingDeleteBtn: false,
      loading: false,
      headers: [
        { text: "Descripción", value: "descripcion" },
        {
          text: "Opciones",
          value: "options",
          sortable: false,
          align: "center",
          width: "110",
        },
      ],
      selected: [],
      dialog: false,
      deleteDialog: false,
      alert: {
        show: false,
        type: "",
        message: "",
      },
      error: "",
      logger: {},
    };
  },
  methods: {
    ...mapActions(["setQueriesAction"]),
    play: function(item) {
      //console.log(item);
      this.$store.dispatch("setFiltersAction", JSON.parse(item.filtros));
      AmplifyEventBus.$emit("set-tab-dashboard-layout-left", "tab-1");
    },
    editQuery: function(item) {
      this.$store.dispatch("showSaveQueryDialog");
      setTimeout(() => AmplifyEventBus.$emit("edit-saved-query", item), 200);
    },

    deleteQueries: function() {
      this.deleteDialog = true;
    },

    deleteSelected: async function() {
      this.loadingDeleteBtn = true;
      this.loading = true;
      try {
        await deleteConsultas(this.selected);
        AmplifyEventBus.$emit("load-saved-queries");
      } catch (e) {
        console.log(e);
        this.setError(e);
      } finally {
        this.deleteDialog = false;
        this.palabra = "";
        this.loadingDeleteBtn = false;
        this.loading = false;
        this.selected = [];
      }
    },
    refresh: async function() {
      AmplifyEventBus.$emit("load-saved-queries");
    },
    setError(e) {
      this.loadingBtn = false;
      this.error = this.$Amplify.I18n.get(e.message || e);
      this.setAlert({ message: this.error });
      this.logger.error(this.error);
    },
    setAlert: function({ message = "", type = "error" }) {
      this.alert = {
        message,
        type,
        show: message.length > 1 ? true : false,
      };
    },
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters(["queries"]),
  },
  mounted() {
    this.logger = new this.$Amplify.Logger(this.$options.name);
  },
  beforeCreate: function() {
    AmplifyEventBus.$on("load-saved-queries", () => {
      this.setAlert({});
      this.loading = true;
    });

    AmplifyEventBus.$on("end-load-saved-queries", () => {
      this.loading = false;
    });
  },
  beforeDestroy: function() {
    AmplifyEventBus.$off("load-saved-queries");
    AmplifyEventBus.$off("end-load-saved-queries");
  },
};
</script>
